import {FC} from "react";

interface IProps {
  style?: React.CSSProperties;
  borderRadius?: string;
  colorText?: string;
  children: React.ReactNode;
  height?: string;
  isButton?: boolean;
  onOpenModel?: () => void;
}

export const CustomDarkContainer: FC<IProps> = ({
  style = {},
  children,
  borderRadius = "12px",
  colorText = "#FAFAFA",
  height = "44px",
  isButton = false,
  onOpenModel,
}) => {
  return (
    <div
      onClick={onOpenModel}
      style={{
        borderRadius,
        color: colorText,
        height,
        cursor: isButton ? "pointer" : "default",
        background: "#161a1d",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        padding: "0 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "content-between",
        gap: "10px",

        ...style,
      }}
    >
      {children}
    </div>
  );
};
